// Illustrated category icons (white broiler, colored local hen, eggs, guinea fowl, duck, quail)
const BASE = "https://static.prod-images.emergentagent.com/jobs/643c140f-97bc-4114-97ee-77b119d84dac/images";

export const CATEGORY_ICONS = {
  "poulet-de-chair": `${BASE}/00ef2d616ac77677c7e50618b076b0fd409237b7a8ed4ba2cd7c946d7283302c.jpeg`,
  "poulet-local": `${BASE}/fa8eb875b2bdc242800d347ee12f0f87c62f1bd8bfcccea196bd1c5563a9b869.jpeg`,
  "oeufs": `${BASE}/de26e0a55bddf5943ea2200d3fe2c61e22050a9f9138a7736c5afa829710b829.jpeg`,
  "pintade": `${BASE}/8c7115c6f29b41aeeba4b9ecd74aed4f3aae9b3065962963ff17d88c3d708d79.jpeg`,
  "canard": `${BASE}/8ac57ce1d07c79fc6e3e1916b403bb3ade288b9c05cee650003033c16ce1372d.jpeg`,
  "caille": `${BASE}/20df1317768ca0533727eba65e9be09821f09f16434294bba8eaad4c4497bf2f.jpeg`,
};

export const categoryIcon = (slug) => CATEGORY_ICONS[slug] || CATEGORY_ICONS["poulet-de-chair"];
